(() => {
  const roots = document.querySelectorAll("[data-alumni-root]")
  for (const root of roots) {
    if (!(root instanceof HTMLElement) || root.dataset.alumniReady === "true") continue
    root.dataset.alumniReady = "true"
    bindAlumni(root)
  }

  function yearBounds(now) {
    return { min: 1960, max: now.getUTCFullYear() + 6 }
  }

  function linkedInOk(value) {
    const trimmed = value.trim()
    if (!trimmed) return true
    let candidate = trimmed
    if (!/^https?:\/\//i.test(candidate)) {
      if (/^(?:www\.)?(?:[a-z]{2}\.)?linkedin\.com\//i.test(candidate)) candidate = `https://${candidate}`
      else return false
    }
    try {
      const url = new URL(candidate)
      if (url.protocol !== "https:" && url.protocol !== "http:") return false
      const host = url.hostname.toLowerCase()
      if (host !== "linkedin.com" && !host.endsWith(".linkedin.com")) return false
      if (url.protocol !== "https:") return false
      const parts = url.pathname.split("/").filter(Boolean)
      const kind = (parts[0] || "").toLowerCase()
      return (kind === "in" || kind === "pub") && (parts[1] || "").length >= 2
    } catch {
      return false
    }
  }

  function bindAlumni(root) {
    const form = root.querySelector("[data-alumni-form]")
    const submit = root.querySelector("[data-alumni-submit]")
    const alert = root.querySelector("[data-alumni-alert]")
    if (!(form instanceof HTMLFormElement) || !(submit instanceof HTMLButtonElement)) return
    const apiBase = (root.dataset.apiBase || "").replace(/\/$/, "")
    let sending = false

    const showAlert = (message) => {
      if (!(alert instanceof HTMLElement)) return
      alert.textContent = message
      alert.hidden = !message
    }
    const clearErrors = () => {
      for (const node of root.querySelectorAll("[data-error-for]")) {
        if (node instanceof HTMLElement) {
          node.textContent = ""
          node.hidden = true
        }
      }
      for (const input of form.querySelectorAll("input")) input.removeAttribute("aria-invalid")
    }
    const showErrors = (errors) => {
      if (!errors) return
      let first = null
      for (const [name, message] of Object.entries(errors)) {
        const node = root.querySelector(`[data-error-for="${name}"]`)
        const input = form.elements.namedItem(name)
        if (node instanceof HTMLElement) {
          node.textContent = String(message)
          node.hidden = false
        }
        if (input instanceof HTMLInputElement) {
          input.setAttribute("aria-invalid", "true")
          if (!first) first = input
        }
      }
      if (first) first.focus()
    }
    const clientErrors = (data) => {
      const errors = {}
      const bounds = yearBounds(new Date())
      const name = String(data.get("fullName") || "").trim()
      const year = String(data.get("graduationYear") || "").trim()
      const email = String(data.get("email") || "").trim()
      const linkedin = String(data.get("linkedin") || "")
      if (name.length < 2) errors.fullName = "Enter your full name."
      if (!/^\d{4}$/.test(year) || Number(year) < bounds.min || Number(year) > bounds.max) {
        errors.graduationYear = `Enter a graduation year between ${bounds.min} and ${bounds.max}.`
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Enter a valid email address."
      if (!linkedInOk(linkedin)) errors.linkedin = "Enter a LinkedIn profile URL, or leave this blank."
      return errors
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault()
      if (sending) return
      clearErrors()
      showAlert("")
      const data = new FormData(form)
      const errors = clientErrors(data)
      if (Object.keys(errors).length) {
        showErrors(errors)
        return
      }
      sending = true
      submit.disabled = true
      submit.setAttribute("aria-busy", "true")
      const label = submit.textContent
      submit.textContent = "Joining…"
      try {
        const response = await fetch(`${apiBase}/api/public/alumni`, {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({
            fullName: String(data.get("fullName") || ""),
            graduationYear: String(data.get("graduationYear") || ""),
            email: String(data.get("email") || ""),
            linkedin: String(data.get("linkedin") || ""),
            major: String(data.get("major") || ""),
            jobTitle: String(data.get("jobTitle") || ""),
            clubAffiliations: String(data.get("clubAffiliations") || ""),
            marketing: data.get("marketing") === "on",
            website: String(data.get("website") || ""),
          }),
        })
        let result = {}
        try {
          result = await response.json()
        } catch {
          result = {}
        }
        if (response.status === 201 && result.ok) {
          const entry = root.querySelector("[data-alumni-entry]")
          const done = root.querySelector("[data-alumni-done]")
          if (entry instanceof HTMLElement) entry.hidden = true
          if (done instanceof HTMLElement) {
            done.hidden = false
            const heading = done.querySelector("h2")
            if (heading instanceof HTMLElement) heading.focus()
          }
          return
        }
        if (result.fieldErrors) showErrors(result.fieldErrors)
        showAlert(result.formError || "The registration could not be saved. Check the connection and try again.")
      } catch {
        showAlert("The registration could not be saved. Check the connection and try again.")
      } finally {
        sending = false
        if (!submit.disabled || submit.getAttribute("aria-busy") === "true") {
          const done = root.querySelector("[data-alumni-done]")
          if (!(done instanceof HTMLElement) || done.hidden) {
            submit.disabled = false
            submit.removeAttribute("aria-busy")
            submit.textContent = label
          }
        }
      }
    })
  }
})()
